jQuery($ => {
  /* -------------------------------------------------------------------------- */
  /*                                    Class                                   */
  /* -------------------------------------------------------------------------- */
  class AppointmentStep {
    constructor(element, options) {
      this._        = element;
      this._element = $(element);
      this._options = options;

      // collect options with data-step-id
      this._nextStepOptions = this._element.find('.o-appointment-step__option--type--next[data-step-id]');
      this._backButton = this._element.find('.o-appointment-step__back');

      this.init();
    }

    init() {
      this.setupHandlers();
      this._element.trigger( 'init', this );
    }

    setupHandlers() {
      // only setup click handler if onOptionClick callback is provided
      if (this._options?.onOptionClick) {
        this._nextStepOptions.on('click', (e) => {
          e.preventDefault();
          const $option = $(e.currentTarget);
          const stepId = $option.data('step-id');
          const href = $option.attr('href') || '';
          this._options.onOptionClick(stepId, {
            href,
            optionElement: e.currentTarget,
          });
        });
      }

      if (this._options?.onBackClick) {
        this._backButton.on('click', (e) => {
          e.preventDefault();
          const href = $(e.currentTarget).attr('href') || '';
          this._options.onBackClick({
            href,
            backElement: e.currentTarget,
          });
        });
      }
    }
  }
  
  /* -------------------------------------------------------------------------- */
  /*                                   jQuery                                   */
  /* -------------------------------------------------------------------------- */
  $.fn.appointment_step = function() {
    // console.log('Initializing appointment step for', this);
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].appointment_step = new AppointmentStep(_[i], opt);
      else
        ret = _[i].appointment_step[opt].apply(_[i].appointment_step, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  // do not auto-initialize appointment step, since it may be used inside appointment scheduler which also has click handlers for options
  // $('.o-appointment-step').appointment_step();
});

jQuery($ => {
  /* -------------------------------------------------------------------------- */
  /*                                    Class                                   */
  /* -------------------------------------------------------------------------- */
  class AppointmentScheduler {
    constructor(element) {
      this._        = element;
      this._element = $(element);
      this._transitionDuration = 260;
      this._stepItemActiveClass = 'o-appointment-scheduler__step-item--is-active';
      this._stepItemLeavingClass = 'o-appointment-scheduler__step-item--is-leaving';
      this._stepItemEnteringClass = 'o-appointment-scheduler__step-item--is-entering';
      this._pageBuilderItemClass = 'o-appointment-scheduler__page-builder-item';
      this._pageBuilderItemActiveClass = 'o-appointment-scheduler__page-builder-item--is-active';
      this._pageBuilderItemLeavingClass = 'o-appointment-scheduler__page-builder-item--is-leaving';
      this._pageBuilderItemEnteringClass = 'o-appointment-scheduler__page-builder-item--is-entering';

      this._stepTrack = this._element.find('.o-appointment-scheduler__steps-track');

      this._pageBuilderTrack = this._element.find('.o-appointment-scheduler__page-builder-track');
      this._stepItemTemplate = document.getElementById('o-appointment-scheduler__step-item-template');

      // collect initial steps
      this._steps = this._element.find('.o-appointment-step');  
      this._isLoadingStep = false;

      this.init();
    }

    init() {
      this._markInitialActiveItems();
      this.setupHandlers();
      this._element.trigger( 'init', this );
    }

    _markInitialActiveItems() {
      const $initialStep = this._stepTrack.find('.o-appointment-scheduler__step-item').first();
      if ($initialStep.length) {
        $initialStep.addClass(this._stepItemActiveClass);
      }

      const $initialPageBuilderItem = this._pageBuilderTrack.find(`.${this._pageBuilderItemClass}`).first();
      if ($initialPageBuilderItem.length) {
        $initialPageBuilderItem.addClass(this._pageBuilderItemActiveClass);
      }
    }

    _initAppointmentStep($stepElement) {
      $stepElement.appointment_step({
        onOptionClick: this._handleStepOptionClick.bind(this),
        onBackClick: this._handleStepBackClick.bind(this),
      });
    }

    async _handleStepOptionClick(stepId, context = {}) {
      if (!stepId || this._isLoadingStep) {
        return;
      }

      this._isLoadingStep = true;

      try {
        this._trimForwardHistory();

        const path = this._extractPathFromHref(context.href);
        const endpoint = this._buildStepEndpoint(stepId, path);
        const response = await fetch(endpoint, {
          method: 'GET',
          credentials: 'same-origin',
        });

        if (!response.ok) {
          throw new Error(`Failed to load step ${stepId}. Status ${response.status}`);
        }

        const payload = await response.json();
        const stepData = payload?.data || {};

        await this._pushNextStep(stepData.rendered_step_content || '');
        await this._pushNextPageBuilderContent(stepData.rendered_page_builder_content || '');
      } catch (error) {
        console.error('Unable to load appointment step.', error);
      } finally {
        this._isLoadingStep = false;
      }
    }

    async _handleStepBackClick() {
      if (this._isLoadingStep) {
        return;
      }

      const $currentStepItem = this._getActiveStepItem();
      const $previousStepItem = $currentStepItem.prev('.o-appointment-scheduler__step-item');

      if (!$currentStepItem.length || !$previousStepItem.length) {
        return;
      }

      const $currentPageBuilderItem = this._getActivePageBuilderItem();
      const $previousPageBuilderItem = $currentPageBuilderItem.prev(`.${this._pageBuilderItemClass}`);

      await this._transitionItems(
        $currentStepItem,
        $previousStepItem,
        this._stepItemActiveClass,
        this._stepItemLeavingClass,
        this._stepItemEnteringClass
      );

      if ($currentPageBuilderItem.length && $previousPageBuilderItem.length) {
        await this._transitionItems(
          $currentPageBuilderItem,
          $previousPageBuilderItem,
          this._pageBuilderItemActiveClass,
          this._pageBuilderItemLeavingClass,
          this._pageBuilderItemEnteringClass
        );
      }
    }

    _extractPathFromHref(href) {
      if (!href) {
        return '';
      }

      try {
        const parsedUrl = new URL(href, window.location.origin);
        return parsedUrl.searchParams.get('path') || '';
      } catch (error) {
        return '';
      }
    }

    _buildStepEndpoint(stepId, path = '') {
      const endpoint = `/wp-json/custom/v1/appointment-steps/step/${encodeURIComponent(stepId)}`;

      if (!path) {
        return endpoint;
      }

      return `${endpoint}?path=${encodeURIComponent(path)}`;
    }

    _getActiveStepItem() {
      return this._stepTrack.find(`.o-appointment-scheduler__step-item.${this._stepItemActiveClass}`).first();
    }

    _getActivePageBuilderItem() {
      return this._pageBuilderTrack.find(`.${this._pageBuilderItemClass}.${this._pageBuilderItemActiveClass}`).first();
    }

    _trimForwardHistory() {
      const $activeStepItem = this._getActiveStepItem();
      if ($activeStepItem.length) {
        $activeStepItem.nextAll('.o-appointment-scheduler__step-item').remove();
      }

      const $activePageBuilderItem = this._getActivePageBuilderItem();
      if ($activePageBuilderItem.length) {
        $activePageBuilderItem.nextAll(`.${this._pageBuilderItemClass}`).remove();
      }
    }

    _wait(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    }

    _createStepItem(order) {
      const templateContent = this._stepItemTemplate?.content;
      const templateStepItem = templateContent?.firstElementChild;
      const stepItem = templateStepItem.cloneNode(true);

      stepItem.classList.add(`o-appointment-scheduler__step-item--order--${order}`);

      return $(stepItem);
    }

    async _transitionItems($fromItem, $toItem, activeClass, leavingClass, enteringClass) {
      if (!$fromItem.length || !$toItem.length) {
        return;
      }

      $fromItem.addClass(leavingClass);
      await this._wait(this._transitionDuration);

      $fromItem.removeClass(`${activeClass} ${leavingClass}`);

      $toItem.addClass(`${activeClass} ${enteringClass}`);
      await this._wait(this._transitionDuration);

      $toItem.removeClass(enteringClass);
    }

    async _pushNextStep(renderedStepContent) {
      if (!renderedStepContent) {
        return;
      }

      const $currentStepItem = this._getActiveStepItem();

      const order = this._stepTrack.find('.o-appointment-scheduler__step-item').length + 1;
      const $newStepItem = this._createStepItem(order);
      $newStepItem.html(renderedStepContent);
      this._stepTrack.append($newStepItem);

      const $newStep = $newStepItem.find('.o-appointment-step').first();
      if ($newStep.length) {
        this._initAppointmentStep($newStep);
      }

      await this._transitionItems(
        $currentStepItem,
        $newStepItem,
        this._stepItemActiveClass,
        this._stepItemLeavingClass,
        this._stepItemEnteringClass
      );
    }

    async _pushNextPageBuilderContent(renderedPageBuilderContent) {
      const $currentPageBuilderItem = this._getActivePageBuilderItem();

      const $newPageBuilderItem = $(`<div class="${this._pageBuilderItemClass}"></div>`);
      $newPageBuilderItem.html(renderedPageBuilderContent || '');
      this._pageBuilderTrack.append($newPageBuilderItem);

      if ($currentPageBuilderItem.length) {
        await this._transitionItems(
          $currentPageBuilderItem,
          $newPageBuilderItem,
          this._pageBuilderItemActiveClass,
          this._pageBuilderItemLeavingClass,
          this._pageBuilderItemEnteringClass
        );
        return;
      }

      $newPageBuilderItem.addClass(this._pageBuilderItemActiveClass);
    }

    setupHandlers() {
      // loop throught existing steps and init
      this._steps.each((index, step) => {
        this._initAppointmentStep($(step));
      });
    }
  }
  
  /* -------------------------------------------------------------------------- */
  /*                                   jQuery                                   */
  /* -------------------------------------------------------------------------- */
  $.fn.appointment_scheduler = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].appointment_scheduler = new AppointmentScheduler(_[i], opt);
      else
        ret = _[i].appointment_scheduler[opt].apply(_[i].appointment_scheduler, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  $('.o-appointment-scheduler').appointment_scheduler();
});
